
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ServerErrorSvg extends Vue{
	@Prop({ default: 178 }) private size: number;
}
